function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import AppDetails from '../containers/appDetails';
import ServiceDetails from '../containers/serviceDetails';
import { ensureAppDetailsData, ensureServiceDetailsData, getProductDetail } from '@shared/actions/thunkActions';
import { useHydration } from '@shared/hooks/useHydration';
import { CatalogOfferType } from '@src/server/viewModels/serviceApiModel';
function ensureProductDetail(dispatch, configState, entityId, isPrivate) {
    return _ensureProductDetail.apply(this, arguments);
}
function _ensureProductDetail() {
    _ensureProductDetail = _async_to_generator(function*(dispatch, configState, entityId, isPrivate) {
        const viewProduct = yield getProductDetail(entityId, configState);
        const { catalogOfferType } = viewProduct;
        if (catalogOfferType === CatalogOfferType.ConsultingServices) {
            yield dispatch(ensureServiceDetailsData(entityId));
        } else {
            yield dispatch(ensureAppDetailsData(entityId, isPrivate));
        }
    });
    return _ensureProductDetail.apply(this, arguments);
}
export const ensureAsyncDataSSR = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*(dispatch, getState, params) {
        const { entityId } = params;
        const isPrivate = !!params.privateOffer || !!params.private;
        if (isPrivate) {
            return;
        }
        yield ensureProductDetail(dispatch, getState().config, entityId, false);
    });
    return function ensureAsyncDataSSR(dispatch, getState, params) {
        return _ref.apply(this, arguments);
    };
}();
const CommonPageDetails = ()=>{
    const isHydrated = useHydration();
    const params = useParams();
    const { entityId, privateOffer, private: isPrivate } = params; // privateOffer and private are the same, the private is prepration for url changes
    const configState = useSelector(({ config })=>config);
    const servicesIdMap = useSelector(({ services })=>services.idMap);
    const appIdMap = useSelector(({ apps })=>apps.idMap);
    const dispatch = useDispatch();
    const entityIdLower = entityId.toString().toLowerCase();
    const serviceIndex = servicesIdMap[`${entityIdLower}`];
    const appIndex = appIdMap[`${entityIdLower}`];
    useEffect(()=>{
        if (!(serviceIndex >= 0 || appIndex >= 0)) {
            const isPrivateOffer = !!privateOffer || !!isPrivate;
            ensureProductDetail(dispatch, configState, entityId, isPrivateOffer);
        }
    }, [
        entityId,
        servicesIdMap,
        appIdMap,
        serviceIndex,
        appIndex,
        configState,
        privateOffer,
        isPrivate,
        dispatch
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            appIndex >= 0 && isHydrated && /*#__PURE__*/ _jsx(AppDetails, {}),
            serviceIndex >= 0 && isHydrated && /*#__PURE__*/ _jsx(ServiceDetails, {})
        ]
    });
};
export default CommonPageDetails;
